import { useParams } from 'react-router-dom';
import { useCallback, useMemo, useState } from 'react';
import { ResourceDto } from '../../../../../api-client';
import { AddBusinessUnitModalComponent } from './AddBusinessUnitModal.types';
import { Button, Flexbox, Modal } from '@hiiretail/synergy-ui';
import { Option } from '@hiiretail/synergy-ui/dist/types/components/inputs/Select/Select.types';
import { BusinessUnitSelect, CancelButton } from './AddBusinessUnitModal.styles';
import { UpdateBusinessUnitData } from '../../../GroupDetails.types';

export const AddBusinessUnitModal: AddBusinessUnitModalComponent = ({
  open,
  onClose,
  role,
  businessUnits,
  addBusinessUnit,
  isAdding,
}) => {
  const { id } = useParams<{ id: string }>();
  const [selectedBusinessUnit, setSelectedBusinessUnit] = useState<{
    value: ResourceDto;
    label: string;
  } | null>(null);

  const options = useMemo(
    () =>
      businessUnits
        ?.filter((bu) => !role?.bindings.find((b) => b === bu.id))
        .map((businessUnit) => ({
          value: businessUnit,
          label: `${businessUnit.id} ${businessUnit.name}`,
        })),
    [businessUnits, role],
  );

  const onChange = useCallback(
    (newOption) => {
      setSelectedBusinessUnit(newOption);
    },
    [setSelectedBusinessUnit],
  );

  const onSubmit = () => {
    const data = {
      groupId: id,
      roleId: role.roleId,
      bindings: [...role.bindings, selectedBusinessUnit?.value.id as string],
      isCustom: role.isCustom,
    } as UpdateBusinessUnitData;
    addBusinessUnit(data);
  };

  return (
    <Modal
      data-testid="add-business-unit-modal"
      title="Add resource"
      onClose={onClose}
      open={open}
      footer={
        <Flexbox container justifyContent="flex-end">
          <CancelButton disabled={isAdding} onClick={onClose} variant="secondary">
            Cancel
          </CancelButton>
          <Button disabled={isAdding || !selectedBusinessUnit} onClick={onSubmit} type="submit">
            Submit
          </Button>
        </Flexbox>
      }
    >
      <BusinessUnitSelect
        options={options as unknown as Option[]}
        name="businessUnits"
        label="Select resources to add"
        onChange={onChange}
        fullWidth
      />
    </Modal>
  );
};
